import { UUID } from "uuidjs";

const receiptResult = (success, invoiceAgent, providerAgent, vatInvoice = false, amount, extID = null, error = null, qrCodes = null) => {
  if (success) {
    let invNumber = extID ? extID : UUID.generate()
    return {
      success: true,
      data: {
        fiscal: true,
        invoiceAgent,
        amount,
        extID: invNumber,
        vatInvoice,
        qrCodes: qrCodes,
        provider: {
          agent: providerAgent,
          vatInvoice,
          invoiceNumber: invNumber,
          grossTotal: amount
        }
      }
    }
  } else {
    return {
      success: false,
      data: {
        fiscal: true,
        invoiceAgent: invoiceAgent,
        error: error
      }
    }
  }
}

export {
  receiptResult
}